var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1568_24119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4766 11.25H40.7266V10.5C40.7266 9.50544 40.3315 8.55161 39.6282 7.84835C38.9249 7.14509 37.9711 6.75 36.9766 6.75H12.9766C11.982 6.75 11.0282 7.14509 10.3249 7.84835C9.62165 8.55161 9.22656 9.50544 9.22656 10.5V11.25H5.47656C4.98411 11.25 4.49647 11.347 4.0415 11.5355C3.58653 11.7239 3.17313 12.0001 2.82491 12.3483C2.12165 13.0516 1.72656 14.0054 1.72656 15V18C1.72904 20.1873 2.59903 22.2843 4.14567 23.8309C5.69231 25.3775 7.78929 26.2475 9.97656 26.25H10.1209C11.0819 28.9577 12.7638 31.3517 14.9852 33.174C17.2066 34.9962 19.8832 36.1776 22.7266 36.5906V39.75H18.9766C18.3798 39.75 17.8075 39.9871 17.3856 40.409C16.9636 40.831 16.7266 41.4033 16.7266 42C16.7266 42.5967 16.9636 43.169 17.3856 43.591C17.8075 44.0129 18.3798 44.25 18.9766 44.25H30.9766C31.5733 44.25 32.1456 44.0129 32.5676 43.591C32.9895 43.169 33.2266 42.5967 33.2266 42C33.2266 41.4033 32.9895 40.831 32.5676 40.409C32.1456 39.9871 31.5733 39.75 30.9766 39.75H27.2266V36.5831C33.0278 35.7375 37.8259 31.6706 39.7891 26.25H39.9766C42.1638 26.2475 44.2608 25.3775 45.8075 23.8309C47.3541 22.2843 48.2241 20.1873 48.2266 18V15C48.2266 14.0054 47.8315 13.0516 47.1282 12.3483C46.4249 11.6451 45.4711 11.25 44.4766 11.25ZM6.22656 18V15.75H9.22656V21C9.22656 21.2269 9.22656 21.4519 9.24344 21.6769C8.39299 21.5073 7.62758 21.0483 7.07752 20.3779C6.52746 19.7075 6.22674 18.8672 6.22656 18ZM36.2266 20.8312C36.2266 27.0806 31.2184 32.2031 25.0628 32.25C23.5782 32.2614 22.106 31.9788 20.7311 31.4185C19.3562 30.8583 18.1059 30.0314 17.052 28.9856C15.9982 27.9398 15.1618 26.6958 14.5911 25.3252C14.0203 23.9546 13.7265 22.4847 13.7266 21V11.25H36.2266V20.8312ZM43.7266 18C43.7266 18.8683 43.4252 19.7097 42.874 20.3806C42.3228 21.0515 41.5559 21.5103 40.7041 21.6788C40.7191 21.3975 40.7266 21.1163 40.7266 20.8312V15.75H43.7266V18Z",
    fill: "url(#paint0_linear_1568_24119)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1568_24119",
    x1: 24.9766,
    y1: 6.75,
    x2: 24.9766,
    y2: 44.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1568_24119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.c1862ef28e6aad47d933ba712d01107f.svg";
export { ForwardRef as ReactComponent };